import theme from 'common/theme'
import styled from 'styled-components'

const Container = styled.div`
  height: ${({ height }) => height || '2px'};
  width: ${({ width }) => width};
  position: relative;
`

const BaseBox = styled.div`
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: ${({ borderRadius }) => borderRadius};
  transition: width 2s ease-in-out;
`

const Background = styled(BaseBox)`
  background: ${({ background }) =>
    background || `${theme.colors.grayLight}`};
  width: 100%;
`

const ProgressBar = styled(BaseBox)`
  background: ${({ progressColor }) =>
    progressColor || `${theme.colors.red}`};
  width: ${({ percent }) => (percent > 100 ? 100 : percent)}%;
  border-radius: ${({ borderRadius }) => borderRadius};
`

interface IProgress {
  width?: string
  height?: string
  borderRadius?: string
  background?: string
  progressColor?: string
  percent: number
}

function Progress({
  height,
  width,
  borderRadius,
  percent,
  background,
  progressColor,
}: IProgress): JSX.Element {
  return (
    <Container
      height={height}
      width={width}
      data-testid="progress-component"
    >
      <Background
        background={background}
        borderRadius={borderRadius}
      />
      <ProgressBar
        percent={percent}
        progressColor={progressColor}
        borderRadius={borderRadius}
      />
    </Container>
  )
}

export default Progress
